import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "top-carousel mb-5"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Slide = _resolveComponent("Slide")!
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_Carousel = _resolveComponent("Carousel")!

  return (_ctx.slides?.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Carousel, {
          autoplay: _ctx.slides?.length > 1 ? _ctx.bannersConfig : 0,
          "wrap-around": true
        }, _createSlots({
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide) => {
              return (_openBlock(), _createBlock(_component_Slide, {
                key: slide.id
              }, {
                default: _withCtx(() => [
                  (_ctx.slides?.length > 1)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "carousel__item",
                        src: slide.image?.link
                      }, null, 8, _hoisted_2))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        class: "carousel__item",
                        src: slide.image?.link,
                        style: _normalizeStyle(`min-height: ${slide?.image.metadata?.height}px`)
                      }, null, 12, _hoisted_3))
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 2
        }, [
          (_ctx.slides?.length !== 1)
            ? {
                name: "addons",
                fn: _withCtx(() => [
                  _createVNode(_component_Navigation),
                  _createVNode(_component_Pagination)
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["autoplay"])
      ]))
    : _createCommentVNode("", true)
}